import { FunctionComponent, PropsWithChildren, useLayoutEffect, useMemo, useState } from "react";
import { SchemaContext } from "context-for/schema/schema.context";
import { getRootElement, setAttribute } from "./schema-provider.utilities";
import { useFlags } from "hooks-for/feature-flags";
import { FEATURE_FLAGS } from "types-for/feature-flags";
import { WatchtowerVersion } from "@edgetier/watchtower-types";

/**
 * SchemaProvider component.
 * @param props.children Children components to be wrapped by the SchemaProvider.
 * @returns The rendered component.
 */
export const SchemaProvider: FunctionComponent<PropsWithChildren<{}>> = ({ children }) => {
    const [isInitialized, setIsInitialized] = useState(false);
    const flags = useFlags([FEATURE_FLAGS.Watchtower2_0]);

    const currentVersion = useMemo(
        () => (flags[FEATURE_FLAGS.Watchtower2_0].enabled ? WatchtowerVersion.V2 : WatchtowerVersion.V1),
        [flags]
    );

    useLayoutEffect(() => {
        setAttribute(getRootElement(), "data-watchtower-version", currentVersion);
        setIsInitialized(true);
    }, [flags, currentVersion]);

    return (
        <SchemaContext.Provider
            value={{
                isInitialized,
                watchtowerVersion: currentVersion,
                isV1: currentVersion === WatchtowerVersion.V1,
                isV2: currentVersion === WatchtowerVersion.V2,
            }}
        >
            {children}
        </SchemaContext.Provider>
    );
};
